$(document).ready(function() {
    $('.slick-slider-home').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow:3,
      dots: true,
      arrows:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });  

});